import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import CreditBalanceSection from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Settings/CreditBalanceSection';

const ContentCreditsInnerPage = () => {
  return (
    <Flex flexDirection="column" gap={48}>
      <CreditBalanceSection />
    </Flex>
  );
};

export default ContentCreditsInnerPage;

